import {getLanguageFromUrl} from '../../abstracts/utilities.js';

export function googleMapsApiLoader (consent, callbackAllowed = () => {}, callbackDisallowed = () => {}) {
    if (consent) {

        import('@googlemaps/js-api-loader').then(({Loader}) => {

            const loader = new Loader({
                apiKey: 'AIzaSyBtWF325CALZo-PVleNKlyBDaZiLhY9g_U',
                version: "weekly",
                libraries: ['geometry', 'places'],
                language: document.documentElement.getAttribute('lang')
            });

            callbackAllowed(loader);
        });
    } else {
        callbackDisallowed();
    }
}

export function handleModuleConsentText (el, accepted) {
    if(!el) return;

    if(accepted) {
        el.classList.add('d-none');
    } else {
        el.classList.remove('d-none');
    }
}

export function showFallbackConsentText (el) {
    if(!el) return;

    let message = {
        de: {
            title: 'Ihr Einverständnis wird benötigt.',
            description: 'Unser Consent Management Tool kann zur Zeit nicht geladen werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut und deaktivieren Sie die Ad- und Script-Blocker in Ihrem Browser, um das Consent Management Tool benutzen zu können.'
        },
        en: {
            title: 'Your consent is required.',
            description: 'Our consent management tool cannot be loaded at this time. Please try again later and disable the ad and script blockers in your browser to use the consent management tool.'
        },
        fr: {
            title: 'Votre consentement est nécessaire.',
            description: 'Notre outil de gestion du consentement ne peut actuellement pas être chargé. Veuillez réessayer ultérieurement et désactiver les bloqueurs de publicités et de scripts dans votre navigateur afin de pouvoir utiliser l\'outil de gestion du consentement.'
        }
    }

    let title = el.querySelector('.info-box__header > p'),
        content = el.querySelector('.info-box__base > p');

    title.innerText = message[getLanguageFromUrl()].title;
    content.innerText = message[getLanguageFromUrl()].description;
}